import { apiRequest } from './httpClient';

export function getPreferences() {
  return apiRequest('/api/preferences');
}

export function updatePreferences(preferences) {
  return apiRequest('/api/preferences', {
    method: 'PUT',
    body: preferences,
  });
}

export function resetPreferences() {
  return apiRequest('/api/preferences/reset', { method: 'POST' });
}
